export default "__VITE_ASSET__Dfk1P4u7__"